//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: "verificationCode",
    data() {
      return {
        code: "",
        codeText: "60s后重发",
        isSend: true,
        interval: null,
        time: 60,
        placeholder: '',
      };
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      isNeedSend: {
        type: Boolean,
        default: false,
      },
      //是否是弹窗显示时就发送
      isFirstSend: {
        type: Boolean,
        default: false,
      },
      ide: {
        type: String,
        default: ''
      }

    },
    created() {
      if (this.isNeedSend) {
        this.codeText = "发送";
        this.placeholder = '请发送短信验证码';
        this.isSend = false;
      } else {
        this.codeText = "已发送";
        this.placeholder = '请输入短信验证码';
        this.isSend = true;
      }
      if (this.isFirstSend) {
        this.requestCode();
      }
      this.code = this.value;
    },
    watch: {
      value (val) {
        this.code = this.value;
      }
    },
    methods: {
     requestCode() {
       //请求短信验证码
       const $this = this
       $this.codeText = $this.time + "s后重发";
       $this.isSend = true;
       this.placeholder = "请输入短信验证码"
       $this.interval = setInterval(() => {
         $this.time--;
         $this.codeText = $this.time + "s后重发";
         if ($this.time <= 0) {
           $this.codeText = "重新获取";
           $this.time = 60;
           $this.isSend = false;
           $this.placeholder = "请重新发送短信验证码"
           clearInterval($this.interval)
         }
       }, 1000);
       this.$emit('send');

     },
      //验证短信验证码
      verifyCode() {
        this.$emit('confirm');
      },
      updateValue () {
        this.$emit('input', this.code);
      }
    }
  };



// WEBPACK FOOTER //
// ./src/pages/agreement/smsVerifyUser.vue